<template>
  <div class="common-banner"></div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.common-banner {
  width: 100%;
  height: 200px;
  background: url("../../assets/images/v3/common-banner.png") no-repeat top;
}
</style>